import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useDeleteTestDefinitionMutation} from '../hooks/useTestDefinitionsQuery';
import {useTestDefinitionsSelection} from '../hooks/useTestDefinitionsSelection.ts';

export const DeleteRecordButton = () => {

    const deleteMutation = useDeleteTestDefinitionMutation();

    const {
        selection,
        handleClearSelection,
    } = useTestDefinitionsSelection();

    const recordIds = Object.keys(selection)
                            .filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const id of recordIds) {
            await deleteMutation.mutateAsync(id);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);
};
